import React from 'react'
import { Content } from './ElementsStyles'
interface Input_props {
  label: string
  value: string
  height?: string
  fontSize?: string
}

export default function Inputs({
  label,
  value,
  height,
  fontSize,
}: Input_props) {
  return (
    <Content height={height} fontSize={fontSize}>
      <span>{label}</span>
      <p>{value}</p>
    </Content>
  )
}
